module.exports = __webpack_public_path__ + "31b820eeff57163ef25eaade6e171c7c.svg";